import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="lg:col-span-1">
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-film-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg text-background-50 whitespace-nowrap">
                  高清无码指南
                </span>
              </Link>
              <p className="text-sm text-background-400 leading-relaxed">
                国内首个系统性聚焦高清视频编码与画质优化的专业技术内容平台。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                <a href="/category/bianma-biaozhun">内容分类</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/category/bianma-biaozhun" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">编码标准</Link></li>
                <li><Link to="/category/huazhi-youhua" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">画质优化</Link></li>
                <li><Link to="/category/wusun-yasuo" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">无损压缩</Link></li>
                <li><Link to="/category/bofangqi-jianrong" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">播放器兼容</Link></li>
                <li><Link to="/category/zhizuo-liucheng" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">制作流程</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">
                <a href="/about">关于我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">品牌介绍</Link></li>
                <li><a href="/about#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap">联系我们</a></li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base text-background-50 mb-4">联系方式</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-mail-line text-base"></i>
                  <span>contact@hd-guide.cn</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-background-400">
                  <i className="ri-wechat-line text-base"></i>
                  <span>HD-Guide-Official</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-800/60 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; 2024-2026 高清无码指南. 保留所有权利.
            </p>
            <div className="flex items-center gap-6">
              <a href="/" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="/" className="text-sm text-background-500 hover:text-background-300 transition-colors whitespace-nowrap">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}